/*
 * 可编辑表格
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-20 13:45:03
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from 'react';
import { Input, Tooltip } from 'antd';
import cx from 'classnames';
import VerticalIcon from 'Icon/svg/vertical.svg';
import S from './index.less';
// 转置数据
function transformData(data) {
    var result = [];
    data[0].forEach(function (keyData) {
        var relatedData = [];
        for (var i = 1; i < data.length; i++) {
            data[i].forEach(function (item) {
                if (item.lineKey === keyData.extractNum) {
                    relatedData.push(item);
                }
            });
        }
        result.push(__spreadArray([keyData], relatedData, true));
    });
    return result;
}
export default function EditableTable(props) {
    var tableName = props.tableName, dataSource = props.dataSource, onChange = props.onChange, onSelect = props.onSelect;
    var _a = useState(false), isTranspose = _a[0], setIsTranspose = _a[1];
    var _b = useState([]), newDataSource = _b[0], setNewDataSource = _b[1];
    var handleTransposeClick = useCallback(function () {
        setIsTranspose(!isTranspose);
    }, [isTranspose]);
    var handleChange = useCallback(function (value, cell) {
        console.log(value, cell);
        onChange(value, cell);
    }, [onChange]);
    useEffect(function () {
        if (isTranspose) {
            setNewDataSource(transformData(dataSource));
        }
    }, [isTranspose, dataSource, transformData]);
    return (React.createElement("div", { className: S['table-wrapper'] },
        React.createElement("div", { className: S.title },
            React.createElement("div", { className: S.name }, tableName),
            React.createElement("img", { className: S.icon, src: VerticalIcon, onClick: handleTransposeClick })),
        React.createElement("div", { className: S['table-area'] }, !isTranspose ? (React.createElement("table", { border: 1, cellPadding: 0, cellSpacing: 0, className: S.table },
            React.createElement("tbody", null, dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (line, lineIndex) {
                if (lineIndex === 0) {
                    return (React.createElement("tr", { key: lineIndex, className: cx(S.line, S['line-head']) }, line === null || line === void 0 ? void 0 : line.map(function (cell, cellIndex) { return (React.createElement("td", { key: "".concat(lineIndex).concat(cellIndex), className: S.cell }, cell.extractFieldName)); })));
                }
                else {
                    return (React.createElement("tr", { key: lineIndex, className: cx(S.line, S['line-body']) }, line === null || line === void 0 ? void 0 : line.map(function (cell, cellIndex) { return (React.createElement(Tooltip, { destroyTooltipOnHide: true, title: cell.value },
                        React.createElement("td", { key: "".concat(lineIndex).concat(cellIndex), className: S.cell, onMouseMove: function () { return onSelect(cell); } },
                            React.createElement(Input, { className: S['cell-input'], bordered: false, value: cell.value, onChange: function (e) { return handleChange(e.target.value, cell); } })))); })));
                }
            })))) : (React.createElement("table", { border: 1, cellPadding: 0, cellSpacing: 0, className: S['t-table'] },
            React.createElement("tbody", null, newDataSource === null || newDataSource === void 0 ? void 0 : newDataSource.map(function (line, lineIndex) { return (React.createElement("tr", { key: lineIndex, className: S['t-line'] }, line === null || line === void 0 ? void 0 : line.map(function (cell, cellIndex) {
                if (cellIndex === 0) {
                    return (React.createElement("td", { key: "".concat(lineIndex).concat(cellIndex), className: cx(S['t-cell'], S['t-cell-head']) },
                        React.createElement("div", { className: S['text'] }, cell.extractFieldName)));
                }
                else {
                    return (React.createElement(Tooltip, { destroyTooltipOnHide: true, title: cell.value },
                        React.createElement("td", { key: "".concat(lineIndex).concat(cellIndex), className: S['t-cell'], onMouseMove: function () { return onSelect(cell); } },
                            React.createElement(Input, { className: S['t-cell-input'], bordered: false, value: cell.value, onChange: function (e) { return handleChange(e.target.value, cell); } }))));
                }
            }))); })))))));
}
